<!-- <div class="card-wrapper card-space d-flex  p-2">
	<div class="card card-bg card-big p-1 d-flex flex-column">
		<h3 class="card-title h5">{{ link.title }}</h3>
		<p class="card-text font-serif">{{ link.description }}</p>
		<a
			tabindex="0"
			(keyup.enter)="routerService.navigateTo(link.address)"
			class="read-more"
			(click)="routerService.navigateTo(link.address)">
			Vai all'applicazione
			<app-icon name="it-arrow-right"></app-icon>
		</a>
		<div class="p-1 d-flex align-items-center">
			<img src="{{ link.imageUrl }}" class="icon d-none d-sm-inline button-image" />
		</div>
	</div>
</div> -->

<div class="card-wrapper card-space mx-auto h-100">
	<div class="card card-img card-bg no-after">
		<div class="img-responsive-wrapper">
			<div class="img-responsive img-responsive-panoramic">
				<figure class="img-wrapper">
					<img
						src="{{ link.imageUrl }}"
						[title]="'Cover applicazione ' + link.title"
						[alt]="'Immagine di copertina applicazione ' + link.title" />
				</figure>
			</div>
		</div>
		<div class="card-body">
			<h3 class="card-title h4">{{ link.title }}</h3>
			<p class="card-text mb-5">{{ link.description }}</p>
			<a
				tabindex="0"
				(keyup.enter)="routerService.navigateTo(environment.contextRoot + link.address)"
				class="read-more"
				(click)="routerService.navigateTo(environment.contextRoot + link.address)">
				<span class="text">Vai a {{ link.title }}</span>
				<span class="visually-hidden">{{ link.description }}</span>
				<app-icon name="it-arrow-right"></app-icon
			></a>
		</div>
	</div>
</div>
